import Box from '@mui/material/Box';
import Shimmer from './Shimmer';

// Skeleton for the Tests grid (also used by Packages with a different
// card-count default). Matches TestCard's real layout pixel-for-pixel:
//   icon row + title block + parameters row + price row + CTA button.
// The parent grid keeps the same 1/2/3/4 column responsive breakpoints
// as the real page so nothing shifts when data arrives.

const TestCardShimmer = () => (
  <Box
    sx={{
      bgcolor: '#fff',
      border: '1.5px solid var(--border-l)',
      borderRadius: '18px',
      p: { xs: 2.25, md: 2.5 },
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
    }}
  >
    {/* Save-% pill placeholder (top-right, matches real card) */}
    <Shimmer
      width={62}
      height={22}
      rounded={100}
      sx={{ position: 'absolute', top: 12, right: 12 }}
    />

    {/* Emoji icon */}
    <Shimmer width={32} height={32} rounded={6} sx={{ mb: 1.5 }} />

    {/* Title (2 lines) */}
    <Shimmer width="85%" height={13} rounded={4} sx={{ mb: 0.75 }} />
    <Shimmer width="60%" height={13} rounded={4} sx={{ mb: 1 }} />

    {/* Tag / category chip */}
    <Shimmer width={90} height={18} rounded={100} sx={{ mb: 1.5 }} />

    {/* Outcome bullets (2 short lines) */}
    <Shimmer width="75%" height={10} rounded={4} sx={{ mb: 0.5 }} />
    <Shimmer width="60%" height={10} rounded={4} sx={{ mb: 'auto' }} />

    {/* Price row + CTA */}
    <Box sx={{ mt: 2 }}>
      <Shimmer width="50%" height={22} rounded={6} sx={{ mb: 1.25 }} />
      <Shimmer width="100%" height={36} rounded={100} />
    </Box>
  </Box>
);

const TestsShimmer = ({ count = 8 }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(3, 1fr)',
        lg: 'repeat(4, 1fr)',
      },
      gap: { xs: 2, md: 2.5 },
      width: '100%',
    }}
  >
    {Array.from({ length: count }).map((_, i) => <TestCardShimmer key={i} />)}
  </Box>
);

export default TestsShimmer;
